import React from "react";
import { HOTMART_URL, HOTMART_URL_BASIC } from "../../lib/constants";
import {
  Check,
  X,
  ShieldCheck,
  Clock,
  Lock,
  AlertTriangle,
  Gift,
  Award,
  Star,
  CreditCard,
} from "lucide-react";

const SHARED = [
  "Formação teórica completa em Manobrador de Grua Torre de comando",
  "+50 aulas gravadas + atualização todo mês",
  "Acesso por 1 ano à plataforma",
  "Faça o curso pelo celular ou computador — sem horários fixos",
  "Orientação profissional + desconto na aula prática",
];

const ONLY_PRO = [
  "Certificação de 15h via SIGO / Passaporte Qualifica",
  "Avaliação teórica online incluída",
  "Cartão Manobrador oficial CFOMP/SIGO",
];

const BONUSES = [
  {
    title: "Guia PDF: 10 perguntas mais frequentes do SIGO",
    desc: "Respondidas e explicadas pelo Kawan",
    value: 29,
  },
  {
    title: "Checklist diária do Manobrador",
    desc: "O que verificar todos os dias antes de subir",
    value: 19,
  },
  {
    title: "Grupo WhatsApp privado de alunos",
    desc: "Dúvidas, vagas de emprego partilhadas, networking",
    value: 47,
  },
  {
    title: "Lives mensais ao vivo com o Kawan",
    desc: "Pergunta tudo · acesso durante 12 meses",
    value: 97,
  },
];

export default function FinalOffer() {
  const totalBonusValue = BONUSES.reduce((s, b) => s + b.value, 0);

  return (
    <section
      id="oferta"
      className="relative py-24 sm:py-32 bg-[#0A0A0A] border-b border-white/10"
      data-testid="final-offer-section"
    >
      <div aria-hidden="true" className="absolute top-0 left-0 right-0 h-1 warning-stripes" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="text-xs uppercase tracking-[0.3em] text-yellow-400 mb-3">
            A Tua Decisão
          </div>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            ESCOLHE O TEU <br />
            <span className="text-yellow-400">PACOTE.</span>
          </h2>
        </div>

        {/* Two packages */}
        <div className="grid lg:grid-cols-2 gap-6 lg:gap-8 items-stretch">
          {/* BASIC PACKAGE */}
          <PackageCard
            testId="package-basic"
            label="Pacote Essencial"
            subtitle="Só o conteúdo — sem certificado"
            description="Apenas para quem já tem certificação SIGO ou quer estudar por curiosidade pessoal. Não serve para trabalhar como manobrador em PT."
            priceBig="37"
            priceNote="+ IVA"
            originalPrice={null}
            ctaText="QUERO SÓ O CONTEÚDO"
            ctaHref={HOTMART_URL_BASIC}
            includes={SHARED}
            excludes={ONLY_PRO}
            bonuses={[]}
            highlighted={false}
          />

          {/* COMPLETE PACKAGE - highlighted */}
          <PackageCard
            testId="package-pro"
            label="Pacote Completo"
            subtitle="Conteúdo + Certificação SIGO + 4 Bónus"
            priceBig="147"
            priceNote="+ IVA"
            originalPrice="279€"
            savings="Poupa 132€"
            ctaText="QUERO O MEU CARTÃO SIGO"
            ctaHref={HOTMART_URL}
            includes={[...SHARED, ...ONLY_PRO]}
            excludes={[]}
            bonuses={BONUSES}
            totalBonusValue={totalBonusValue}
            highlighted={true}
            badge="Recomendado · 92% dos alunos escolhem"
          />
        </div>

        {/* Practical class note */}
        <div className="mt-10 max-w-3xl mx-auto flex items-start gap-3 border border-yellow-400/20 bg-yellow-400/5 p-4">
          <AlertTriangle className="w-5 h-5 text-yellow-400 shrink-0 mt-0.5" />
          <div className="text-sm text-zinc-200">
            <span className="font-semibold text-yellow-400">Aula prática com Kawan:</span> serviço
            opcional, pago à parte, sujeito a agenda. Alunos de qualquer pacote têm desconto de
            aluno sobre o valor público.
          </div>
        </div>

        {/* Guarantee banner */}
        <div className="mt-10 max-w-3xl mx-auto border-2 border-yellow-400/40 bg-gradient-to-r from-yellow-400/5 via-transparent to-yellow-400/5 p-6 sm:p-8 text-center">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center">
              <ShieldCheck className="w-7 h-7 text-black" strokeWidth={2.5} />
            </div>
            <div className="text-left">
              <div className="text-xs uppercase tracking-[0.3em] text-yellow-400">
                Garantia Blindada
              </div>
              <div className="font-display text-2xl text-white">14 DIAS · RISCO ZERO</div>
            </div>
          </div>
          <p className="text-sm text-zinc-300 max-w-xl mx-auto">
            Faz o curso durante 14 dias. Se não estiveres 100% satisfeito, por qualquer motivo —
            basta um email e devolvemos <strong className="text-white">cada cêntimo</strong>, sem
            perguntas, sem burocracia, sem drama. O risco é todo nosso.
          </p>
        </div>

        {/* Payment trust badges */}
        <div className="mt-8 flex flex-col items-center gap-3">
          <div className="flex flex-wrap justify-center gap-4 text-xs uppercase tracking-widest text-zinc-500">
            <span className="flex items-center gap-1.5">
              <Clock className="w-3.5 h-3.5 text-yellow-400" /> Acesso imediato
            </span>
            <span className="text-zinc-700">·</span>
            <span className="flex items-center gap-1.5">
              <Lock className="w-3.5 h-3.5 text-yellow-400" /> Pagamento seguro
            </span>
            <span className="text-zinc-700">·</span>
            <span className="flex items-center gap-1.5">
              <CreditCard className="w-3.5 h-3.5 text-yellow-400" /> Parcelado disponível
            </span>
          </div>
          <PaymentBadges />
        </div>
      </div>
    </section>
  );
}

function PackageCard({
  testId,
  label,
  subtitle,
  description,
  priceBig,
  priceNote,
  originalPrice,
  savings,
  ctaText,
  ctaHref,
  includes,
  excludes,
  bonuses,
  totalBonusValue,
  highlighted,
  badge,
}) {
  return (
    <div
      data-testid={testId}
      className={`relative flex flex-col p-6 sm:p-8 ${
        highlighted
          ? "border-2 border-yellow-400/50 bg-gradient-to-b from-zinc-900 to-black shadow-[0_30px_80px_-40px_rgba(253,224,71,0.4)]"
          : "border border-white/10 bg-zinc-950"
      }`}
    >
      {highlighted && badge && (
        <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-yellow-400 text-black px-4 py-1.5 text-[10px] sm:text-xs uppercase tracking-widest font-display inline-flex items-center gap-1.5 whitespace-nowrap">
          <Star className="w-3 h-3 fill-black" />
          {badge}
        </div>
      )}

      <div className="mb-6">
        <div
          className={`text-xs uppercase tracking-[0.3em] mb-2 ${
            highlighted ? "text-yellow-400" : "text-zinc-500"
          }`}
        >
          {label}
        </div>
        <h3 className="font-display text-2xl sm:text-3xl text-white uppercase leading-tight">
          {subtitle}
        </h3>
        {description && (
          <p className="mt-3 text-sm text-zinc-500 leading-relaxed">{description}</p>
        )}
      </div>

      {/* Price */}
      <div className="mb-6 pb-6 border-b border-white/10">
        <div className="flex items-baseline gap-3 flex-wrap">
          {originalPrice && (
            <span className="text-zinc-500 line-through font-display text-xl">
              {originalPrice}
            </span>
          )}
          <span
            className={`font-display leading-none ${
              highlighted ? "text-7xl sm:text-8xl text-white" : "text-6xl sm:text-7xl text-white"
            }`}
          >
            <span className="text-yellow-400">€</span>
            {priceBig}
          </span>
          <span className="text-zinc-400 text-sm uppercase tracking-widest">{priceNote}</span>
        </div>
        {savings && (
          <span className="inline-block mt-3 bg-yellow-400 text-black px-2 py-1 text-[10px] uppercase tracking-widest font-bold">
            {savings}
          </span>
        )}
        {highlighted && (
          <p className="mt-3 text-xs text-zinc-500">
            Ou até 12× de ~14€ · MBWay · Multibanco · Cartão
          </p>
        )}
      </div>

      {/* Included */}
      <ul className="space-y-3 mb-4">
        {includes.map((it) => (
          <li key={it} className="flex items-start gap-3 text-zinc-200 text-sm">
            <Check className="w-4 h-4 text-yellow-400 shrink-0 mt-0.5" />
            <span>{it}</span>
          </li>
        ))}
      </ul>

      {/* Bonuses stack (only on Complete) */}
      {bonuses && bonuses.length > 0 && (
        <>
          <div className="mt-4 mb-3 flex items-center gap-2">
            <span className="h-px flex-1 bg-yellow-400/20" />
            <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] text-yellow-400 font-bold">
              <Gift className="w-3 h-3" />
              Bónus Exclusivos
            </span>
            <span className="h-px flex-1 bg-yellow-400/20" />
          </div>
          <ul className="space-y-3 mb-5">
            {bonuses.map((b) => (
              <li
                key={b.title}
                className="flex items-start gap-3 text-zinc-200 text-sm bg-yellow-400/5 border border-yellow-400/15 p-3"
              >
                <Gift className="w-4 h-4 text-yellow-400 shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-white leading-tight">{b.title}</div>
                  <div className="text-[11px] text-zinc-400 mt-0.5">{b.desc}</div>
                </div>
                <span className="text-[11px] text-zinc-500 line-through shrink-0">
                  {b.value}€
                </span>
              </li>
            ))}
          </ul>
          <div className="mb-5 flex items-center justify-between bg-black/40 border border-white/10 px-3 py-2 text-[12px] uppercase tracking-widest">
            <span className="text-zinc-400">Valor real dos bónus</span>
            <span className="text-yellow-400 font-bold">
              <span className="line-through text-zinc-600 mr-2">{totalBonusValue}€</span>INCLUÍDO
            </span>
          </div>
        </>
      )}

      {/* Excluded (crossed out for basic) */}
      {excludes && excludes.length > 0 && (
        <>
          <div className="mt-2 mb-3 text-[10px] uppercase tracking-[0.25em] text-red-400/80 flex items-center gap-2">
            <X className="w-3 h-3" />
            Não inclui
          </div>
          <ul className="space-y-3 mb-6">
            {excludes.map((it) => (
              <li
                key={it}
                className="flex items-start gap-3 text-zinc-600 text-sm line-through"
              >
                <X className="w-4 h-4 text-red-500/70 shrink-0 mt-0.5 not-[]:no-underline" />
                <span>{it}</span>
              </li>
            ))}
          </ul>
        </>
      )}

      {/* CTA */}
      <a
        href={ctaHref}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${testId}-cta`}
        className={`mt-auto group inline-flex items-center justify-center gap-3 font-display tracking-wide px-6 py-5 transition-colors w-full text-center ${
          highlighted
            ? "bg-yellow-400 hover:bg-yellow-300 text-black text-base sm:text-lg"
            : "bg-white/10 hover:bg-white/20 text-white border border-white/20 text-sm sm:text-base"
        }`}
      >
        {ctaText}
      </a>

      {!highlighted && (
        <p className="mt-3 text-[11px] text-red-400/80 text-center uppercase tracking-widest">
          Atenção: Este pacote NÃO dá acesso ao cartão SIGO
        </p>
      )}
      {highlighted && (
        <p className="mt-3 text-[11px] text-yellow-400/80 uppercase tracking-widest text-center flex items-center justify-center gap-1.5">
          <Award className="w-3 h-3" /> Com cartão SIGO · Reconhecido PT + UE
        </p>
      )}
    </div>
  );
}

function PaymentBadges() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 mt-2">
      <Badge>VISA</Badge>
      <Badge>Mastercard</Badge>
      <Badge>MBWay</Badge>
      <Badge>Multibanco</Badge>
      <Badge>Hotmart</Badge>
    </div>
  );
}

function Badge({ children }) {
  return (
    <div className="px-3 py-1.5 bg-white/5 border border-white/10 text-[10px] uppercase tracking-widest text-zinc-400 font-bold">
      {children}
    </div>
  );
}
